import { Arrow, Heading_2 as Heading2 } from "@huggg/react-components"
import React from 'react';
import styles from './guided-choice.module.scss';

export const OptionCard = props => {
    const { imgSrc, optionStyle, label, onClick } = props
    return <div style={optionStyle} className={styles.optionCard} onClick={onClick}>
        <div className={styles.imgWrapper}>
            <img alt={label} height={182} src={imgSrc} />
        </div>
        <div className={styles.optionCta}>
            <Heading2>{label}</Heading2>
            <Arrow />
        </div>
    </div >
}